import React, { FC } from 'react';
import { CourseEvent } from 'src/common/models/event';
import { StyleProps } from 'src/lib/styleProps';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import { CleanUnorderedList } from 'src/common/components/List';
import { format } from 'date-fns';
import { typography } from 'src/config/typography';

const ListItem = styled.li`
  margin-top: 0.375rem;
  padding-left: 2.75rem;
  position: relative;
`;

const AgendaTime = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  color: ${colors.pfp3bis};
  left: 0;
  position: absolute;
  top: 0;
`;
export interface CourseEventAgendaListProps {
  courseEvent: CourseEvent;
}

export const CourseEventAgendaList: FC<StyleProps & CourseEventAgendaListProps> = ({
  className,
  style,
  courseEvent,
}) => {
  return (
    <CleanUnorderedList className={className} style={style}>
      {courseEvent.agendaList?.map((agendaEntry, index) => (
        <ListItem key={index}>
          <AgendaTime>{format(agendaEntry.dateTime, 'HH:mm')}</AgendaTime>
          {agendaEntry.item}
        </ListItem>
      ))}
    </CleanUnorderedList>
  );
};
